import React from "react";
import { Grid, TextField, Box, Divider, Tooltip } from "@mui/material";
import Chip from "@mui/material/Chip";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { Alert, AlertTitle } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import SearchField from "react-search-field";

export default function Applications(props) {
  let { OSTYPE, appsetFormFields, appfieldIndex, setNormalport } = props;
  const [customapps, setCustomapps] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState({});
  const [selectedPorts, setSelectedPorts] = React.useState({});
  const [selectedApps, setSelectedApps] = React.useState({});
  const [forversion, setForversion] = React.useState({});
  const [selectedVersions, setSelectedVersions] = React.useState({});
  const [blockapps, setBlockapps] = React.useState(false);
  const [apperror, setApperror] = React.useState(false);
  const [searchitems, setSearchItems] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/customapplist/${OSTYPE}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setCustomapps(resp))
      .catch((error) => {
        console.error(error);
      });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e, index, ports) => {
    const { value } = e.target;
    const isSelected = !selectedValue[value];

    setSelectedValue((prevState) => ({
      ...prevState,
      [value]: isSelected,
    }));

    if (ports !== null) {
      setSelectedPorts((prevState) => ({
        ...prevState,
        [ports]: isSelected,
      }));
      setSelectedApps((prevState) => ({
        ...prevState,
        [ports]: isSelected ? value : "",
      }));
    }

    if (isSelected) {
      const apipostval = value + "-" + OSTYPE;
      fetch(`${process.env.REACT_APP_API_URL}/api/customversionlist/${apipostval}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((resp) =>
          setForversion((prevState) => ({
            ...prevState,
            [index]: resp,
          }))
        )
        .catch((error) => {
          console.error(error);
        });
    } else {
      setForversion((prevState) => ({
        ...prevState,
        [index]: [],
      }));
      setSelectedVersions((prevState) => ({
        ...prevState,
        [value]: "",
      }));
    }
  };

  const handleChangeInput = (e, appname) => {
    const { value } = e.target;
    setSelectedVersions((prevState) => ({
      ...prevState,
      [appname]: value,
    }));
  };

  const handleCancel = () => {
    setOpen(false);
    // appsetFormFields((prevState) => ({
    //   ...prevState,
    //   [appfieldIndex]: null,
    // }));
    setSelectedValue([]);
    setForversion([]);
    setSelectedVersions([]);
    setSelectedApps([]);
    setSelectedPorts([]);
  };


  const handleSumbitClick = () => {
    let assignAppValue = [];
    let assignAppports = [];
    let count = 0;
    customapps.forEach((appdata) => {
      if (selectedValue[appdata.Name]) {
        if (selectedVersions[appdata.Name]) {
          const appval = appdata.Name + selectedVersions[appdata.Name];
          assignAppValue.push(appval);
          assignAppports.push(appdata.Ports);
        } else {
          count++;
        }
      }
    });
    if (count > 0) {
      setApperror(true);
    } else {
      setApperror(false);
      appsetFormFields((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppValue,
      }));
      setNormalport((prevState) => ({
        ...prevState,
        [appfieldIndex]: assignAppports,
      }));
      setOpen(false);
    }
  };

  return (
    <>
      <div>
        <Tooltip title="Select applications"><span>
        <Fab variant="extended" size="small" color="primary" aria-label="add" sx={{ borderRadius: '16px' }}>
          <Chip
            icon={<AddIcon />}
            label="Applications"
            clickable
            color="primary"
            onClick={handleClickOpen}
          />
        </Fab>
        </span></Tooltip>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Applications</DialogTitle>
        {blockapps && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Don't choose multiple applications with the same port!
          </Alert>
        )}
        {apperror && (
          <Alert severity="warning">
            <AlertTitle>Warning</AlertTitle>
            Please make sure all the fields are selected.
          </Alert>
        )}
        <DialogContent dividers>
          <SearchField
            value={searchitems}
            placeholder="Search..."
            onChange={(event) => setSearchItems(event)}
            classNames="test-class"
          />
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <Box>
              {customapps && (
                <React.Fragment>
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Grid container spacing={0} sx={{ mt: 3 }}>
                        <Grid item xs={8}>
                          <Typography variant="h8" gutterBottom>
                            Application
                          </Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <Typography variant="h8" gutterBottom>
                            Version
                          </Typography>
                        </Grid>
                      </Grid>
                      <Divider />
                      {customapps
                        .filter((val) => {
                          if (searchitems === "") {
                            return val;
                          } else if (
                            val.Title.toLowerCase().includes(
                              searchitems.toLowerCase()
                            )
                          ) {
                            return val;
                          }
                        })
                        .map((e, index) => {
                          const ports = e.Ports;
                          const appname = e.Name;
                          return (
                            <Grid container spacing={0} sx={{ mt: 3 }} key={e.Name}>
                              <Grid item xs={8}>
                                <Checkbox
                                  checked={!!selectedValue[e.Name]}
                                  onChange={(e) => handleChange(e, index, ports)}
                                  disabled={
                                    selectedApps[ports] !== e.Name &&
                                    selectedPorts[ports]
                                  }
                                  value={e.Name}
                                  inputProps={{
                                    "aria-label": "primary checkbox",
                                  }}
                                />
                                <Typography variant="h8" gutterBottom>
                                  {e.Title}
                                </Typography>
                                <FormHelperText sx={{ ml: 5 }}>
                                  min req: {e.requirements}
                                </FormHelperText>
                              </Grid>
                              <Grid item xs={2}>
                                <TextField
                                  fullWidth
                                  id={e.Name}
                                  onChange={(e) =>
                                    handleChangeInput(e, appname)
                                  }
                                  required
                                  select
                                  SelectProps={{ native: true }}
                                  autoComplete="name"
                                  value={selectedVersions[e.Name] || ""}
                                  error={Boolean(selectedValue[e.Name] && !selectedVersions[e.Name])}
                                  helperText={selectedValue[e.Name] && !selectedVersions[e.Name] ? 'Version is required' : undefined}
                                >
                                  <option value="">
                                    --Select the Version--
                                  </option>
                                  {forversion[index] && typeof forversion[index] === "string" && 
                                    forversion[index].split(",").map((appdata) => (
                                      <option key={appdata} value={appdata}>
                                        {appdata}
                                      </option>
                                    ))
                                  }
                                </TextField>
                              </Grid>
                            </Grid>
                          );
                        })}
                    </Grid>
                    <Grid item xs={4}>
                      <Box
                        sx={{
                          fontStyle: "italic",
                          height: "100%",
                          backgroundColor: "whitesmoke",
                        }}
                        borderColor="error.main"
                        border={1}
                      >
                        <strong>Chosen Applications:</strong>
                        {customapps.map((e) => {
                          if (selectedValue[e.Name]) {
                            return (
                              <li
                                key={e.Name}
                                style={{ textAlignLast: "center" }}
                              >
                                {e.Name} - {selectedVersions[e.Name] || "<Version>"}
                              </li>
                            );
                          }
                          return null;
                        })}
                      </Box>
                    </Grid>
                  </Grid>
                </React.Fragment>
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Tooltip title="Close dialog"><span>
          <Button onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
            Close
          </Button>
          </span></Tooltip>
          <Tooltip title="Cancel and discard changes"><span>
          <Button onClick={handleCancel} variant="contained" color="secondary" sx={{ borderRadius: '50px' }}>
            Cancel
          </Button>
          </span></Tooltip>
          <Tooltip title="Save selected applications"><span>
          <Button onClick={handleSumbitClick} variant="contained" color="primary" sx={{ borderRadius: '50px' }}>
            Save
          </Button>
          </span></Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
}
